import { isMobileDevice } from "src/components/WidgetMaker/WidgetDnD/isMobileDevice";
import { getImageWrapperStyles } from "../../Testimonials/Utils"
import contentAnimationStyle from '@/components/DesignSystem/AtomicDesignsUtilities/ContentAnimationStyles.module.scss';
import { getCurrentClass } from "src/components/DesignSystem/Widgets2.0/CardFrameCollection/utils";
import { PRODUCT_TESTIMONIALS_CARD_DEFAULT_CONFIGS } from "src/components/WidgetMaker/WidgetDnD/WidgetProperties/ProductTestimonials/ProductTestimonialsConfig";
import { COMMON_LAYOUT_TYPE } from "src/components/DesignSystem/Widgets2.0/ListPresentation/components/Testimonials/Constants";


function ProductImage(props) {
  const { imageUrl, cardFrameConfig, index, productUrl = '', listPresentationConfig } = props;
  const isMobile = isMobileDevice();
  const productImageStyle = getImageWrapperStyles(cardFrameConfig?.productImageShape, index)
  const layoutImageConfig = isMobile ? PRODUCT_TESTIMONIALS_CARD_DEFAULT_CONFIGS[listPresentationConfig?.layoutName]?.productImageMobileConfig  :
   PRODUCT_TESTIMONIALS_CARD_DEFAULT_CONFIGS[listPresentationConfig?.layoutName]?.productImageConfig;
  const isLayout2 = listPresentationConfig?.layoutName === COMMON_LAYOUT_TYPE.TWO;

  function handleClick() {
    if (productUrl) {
      window.open(productUrl, '_blank');
    }
  }
  return (
    <div
      onClick={handleClick}
      className={`tw-relative tw-flex tw-overflow-hidden tw-cursor-pointer tw-w-[100%] ${(isLayout2 && !isMobile) ? 'tw-min-w-[300px]' : ''}`}
      style={{ ...productImageStyle, ...(layoutImageConfig || {}) }}
    >
      <img src={imageUrl} loading="lazy" className={`tw-object-cover tw-max-h-[400px] tw-w-[100%]  ${!isMobile ? contentAnimationStyle[getCurrentClass(cardFrameConfig?.hoverEffect)] : ''} `} />
    </div>
  )
}

export default ProductImage;